const selectors = {
	getIsActionInProgress: state => state.isActionInProgress | {},
};

export default selectors;
